module.exports = __webpack_public_path__ + "01_medium_grey.0855a152.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/01_medium_grey.png
// module id = l3r4
// module chunks = 0